import { render, staticRenderFns } from "./CardNearestCollectors.vue?vue&type=template&id=5e72071a&scoped=true&"
import script from "./CardNearestCollectors.vue?vue&type=script&lang=js&"
export * from "./CardNearestCollectors.vue?vue&type=script&lang=js&"
import style0 from "./CardNearestCollectors.vue?vue&type=style&index=0&id=5e72071a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72071a",
  null
  
)

export default component.exports